import CoreService from '@/core/core.service.js';
import { getCurrentEnv } from '@/utils/common.js';
export default {
  components: {
  },
  data() {
    return {
      url: '',
      encryption: {
        encryptData: ''
      }
    };
  },
  created() {
    this.getEncryption();
  },
  mounted () {
    window.addEventListener('message', (event) =>  {
      if (event.origin === `https://${getCurrentEnv()}web-dmp.cacfintech.com`) {
        var message = event.data;
        // 处理消息
        console.log(message);
        this.$refs && this.$refs.iframe && (this.$refs.iframe.height = message.height + 'px');
      }
    });
  },
  methods: {
    getEncryption() {
      CoreService.getEncryption().then(res => {
        this.encryption = res;
        this.setUrl();
      });
    },
    setUrl () {
      this.url = `https://${getCurrentEnv()}web-dmp.cacfintech.com/#/collect-data${this.encryption.readonly ? '-detail' : '-v6'}?encryption=${this.encryption.encryptData}&outUrl=${window.location.origin}`;
    },
    // 返回
    back () {
      this.$router.go(-1);
    }
  }
};
